import React from 'react'
import { useState,useEffect } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  FormGroup,
  FormFeedback,
  Label,
  Form,
} from "reactstrap";
import { getAgendaByOrganizer,createAgenda,updateAgenda,deleteAgenda } from '../../../api';
import ListCard from "../../../components/common/ListCard/ListCard";
import { PulseLoader } from "react-spinners";
import { images } from '../../../assets/images';
import AgendaModal  from '../../Events/EditQuickEventV2/Components/AgendaModal';
import ConfirmationDialog from '../../../components/common/ConfirmationDialog/ConfirmationDialog';
import { useNightMode } from '../../../contexts/NightModeContext';
import Background from '../../Login/Background';
import PageHeader from '../../../components/common/PageHeader/PageHeader';
import { Search } from 'lucide-react';
import { AgendaData } from '../../Events/EditQuickEventV2/types';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from 'react-toastify';
interface AgendaItem {
    agendaId: string;
    hostImage: string | File | null;
    title: string;
    hostName?: string;
    createdDate: string;
    description: string;
    status: string | boolean;
    isActive: string | boolean;
    startTime: string;
    agendaDate: string;
    endTime: string;
    eventId: string;
    FormData: any;
    }
const Agenda = () => {
    const { isNightMode } = useNightMode();
    const [agendaData, setAgendaData] = useState<AgendaItem[]>([]);
    const [filteredAgendaData, setFilteredAgendaData] = useState<AgendaItem[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isAgendaModalOpen, setIsAgendaModalOpen] = useState(false);
    const [editingAgenda, setEditingAgenda] = useState<AgendaData | undefined>(undefined);
    const [searchTerm , setSearch ] = useState(""); 
    const [confirmationDialog, setConfirmationDialog] = useState({
      isOpen: false,
      title: '',
      message: '',
      onConfirm: () => {},
      type: 'warning' as 'warning' | 'danger' | 'info' | 'success',
      confirmText: 'Yes, Continue',
      cancelText: 'Cancel',
      icon: 'fa-solid fa-exclamation-triangle',
    });
    const handleSearch = (e: any) => {
        const term = e.target.value;
        setSearch(term);

        if (term.trim() === "") {
            setFilteredAgendaData(agendaData);
        } else {
            const filtered = agendaData.filter((agenda) =>
                agenda.title.toLowerCase().includes(term.toLowerCase())
            );
            setFilteredAgendaData(filtered);
        }
    };
    

    useEffect(() => {
    getAgendaList();
    }, []);
    const getAgendaList = async () => {
        try {
            setIsLoading(true);
            const eventData = localStorage.getItem("eventData");
            if (eventData) {
                const eventId = JSON.parse(eventData).eventId;
                const response = await getAgendaByOrganizer();
                const agendas = response?.data;
                if (agendas) {
                    const filteredAgendas = agendas.filter(
                        (item: AgendaItem) => item.eventId === eventId
                    );
                    setAgendaData(filteredAgendas); 
                    console.log("Filtered Agendas:", filteredAgendas); 
                    setFilteredAgendaData(filteredAgendas); 
                } 
            }
        } catch (error) {
            console.error("Error fetching agenda data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const formatTime12Hour = (time24: string) => {
        if (!time24) return "N/A";
        const [hourStr, minuteStr] = time24.split(":");
        let hour = parseInt(hourStr, 10);
        const minute = minuteStr;
        const ampm = hour >= 12 ? "PM" : "AM";
        hour = hour % 12 || 12;
        return `${hour}:${minute} ${ampm}`;
    };
    const closeConfirmationDialog = () => {
    setConfirmationDialog((prev) => ({ ...prev, isOpen: false }));
  };

  const handleAddAgenda = () => {
    setEditingAgenda(undefined);
    setIsAgendaModalOpen(true);
  };

  const handleEditAgenda = (agenda: AgendaItem | AgendaData) => {
    setEditingAgenda(agenda as AgendaData);
    setIsAgendaModalOpen(true);
    };

  const handleDeleteAgenda = (agenda: AgendaItem) => {
    setConfirmationDialog({
      isOpen: true,
      title: "Delete Agenda",
      message: `Are you sure you want to delete <strong>${agenda.title}</strong>?`,
      type: "danger",
      icon: "fa-solid fa-trash",
      confirmText: "Yes, Delete",
      cancelText: "Cancel",
      onConfirm: async () => {
        try {
          setIsLoading(true);
          await deleteAgenda(agenda.agendaId);
          closeConfirmationDialog();
          getAgendaList();
        } catch (err) {
          console.error("Error deleting agenda:", err);
        } finally {
          setIsLoading(false);
        }
      },
    });
  };

  const handleSaveAgenda = async (agenda: AgendaData) => {
  setIsLoading(true);
  try {
    const eventData = localStorage.getItem("eventData");
    if (!eventData) throw new Error("Event not found");

    const eventId = JSON.parse(eventData).eventId;
    const eventDate = JSON.parse(eventData).eventDate;

    const formData = new FormData();
    formData.append("eventId", eventId);
    formData.append("title", agenda.title);
    formData.append("description", agenda.description);
    formData.append("startTime", agenda.startTime);
    formData.append("endTime", agenda.endTime);
    formData.append("hostName", agenda.hostName || "");
    formData.append("agendaDate", eventDate);
    formData.append("isActive", "true");
    if (editingAgenda) {
      await updateAgenda(editingAgenda.agendaId, formData);
      toast.success("Agenda updated successfully");
    } else {
      await createAgenda(formData);
      toast.success("Agenda created successfully");
    }

    setIsAgendaModalOpen(false);
    setEditingAgenda(undefined);
    getAgendaList();
  } catch (e: any) {
    console.error("Error saving agenda:", e);
    const apiMessage =
      e?.response?.data?.message ||
      e?.message ||
      "Something went wrong while saving the agenda";

    toast.error(apiMessage);
  } finally {
    setIsLoading(false);
  }         
};


  return (
    <div className={`contact-list-container ${isNightMode ? 'text-white' : 'text-dark'}`}>
      <Background />
      <ToastContainer position="top-right" autoClose={2000} />
      <PageHeader
        title="Agenda List"
        subtitle="Plan and schedule event segments, guest speakers, keynotes, and track session timelines."
        isLoading={isLoading}
        actions={
          <Button color="danger" onClick={handleAddAgenda} className="v3-btn-primary h_40 d-flex align-items-center">
            <i className="fa-solid fa-plus me-2"></i> Add New Agenda
          </Button>
        }
      />

      <div className="contact-filter-card mb-4 mt-4">
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">
          <div className="position-relative flex-grow-1 w-100">
            <Search className="position-absolute start-0 top-50 translate-middle-y ms-3 contact-sub-text" size={18} />
            <input
              type="text"
              className="contact-search-input"
              placeholder="Search agenda by title..."
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>

      <div className="mt-4">
                               {isLoading && (
                                  <div className="d-flex justify-content-center py-4">
                                    <PulseLoader color="#3470ca" size={9} speedMultiplier={1} />
                                  </div>
                                )}
                              {filteredAgendaData.length > 0 ? (
                                filteredAgendaData.map((agenda) => (
                                    <ListCard
                                        key={agenda.agendaId}
                                        cardData={{
                                            icon: "fa-solid fa-tasks",
                                            name: agenda.title,
                                            description: agenda.description,
                                            startDate: agenda.createdDate,
                                            // status: agenda.isActive ? "Active" : "Inactive",
                                            optionHead1: "Start Time",
                                            option1: formatTime12Hour(agenda.startTime),
                                            optionIcon1: "fa-solid fa-clock",
                                            optionHead2: "End Time",
                                            option2: formatTime12Hour(agenda.endTime),
                                            optionIcon2: "fa-solid fa-clock",
                                            date: agenda.agendaDate,
                                        }}
                                        onEdit={() => handleEditAgenda(agenda)}
                                        onDelete={() => handleDeleteAgenda(agenda)}
                                    />
                                ))
                            ) : (
                                !isLoading && <p className="text-muted">No Agenda available</p>
                            )}
                            </div>
        <AgendaModal
            isOpen={isAgendaModalOpen}
            toggle={() => setIsAgendaModalOpen(false)}
            onSubmit={handleSaveAgenda}
            isLoading={isLoading}
            agenda={editingAgenda}
        />   
    {/* Confirmation Dialog */}
          <ConfirmationDialog
            isOpen={confirmationDialog.isOpen}
            toggle={closeConfirmationDialog}
            onConfirm={confirmationDialog.onConfirm}
            title={confirmationDialog.title}
            message={confirmationDialog.message}
            type={confirmationDialog.type}
            confirmText={confirmationDialog.confirmText}
            cancelText={confirmationDialog.cancelText}
            icon={confirmationDialog.icon}
          />         
        </div>
      )
    }
    export default Agenda